import { post, get, put } from '../utils/request';

export const list = (data) => get('/source/blacklist/page', data)

export const add = (data) => post('/source/blacklist/add', data)

export const update = (data) => put('/source/blacklist/edit', data)

export const detail = (id) => put(`/source/blacklist/detail/${id}`)

export const deletes = (data) => post(`/source/blacklist/del`, data)

export default { list, add, update, detail, deletes }
